import { render, staticRenderFns } from "./NewDocumentsRegisterView.vue?vue&type=template&id=45c03b64&"
import script from "./NewDocumentsRegisterView.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentsRegisterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports